import React, { h, render } from "preact"; // eslint-disable-line @typescript-eslint/no-unused-vars

import App from "./App"; // eslint-disable-line @typescript-eslint/no-unused-vars

function init() {
  const el = document.getElementById("dividend-calculator-app");
  if (el) {
    const { dividendData } = el.dataset;
    const data = dividendData ? JSON.parse(dividendData) : undefined;
    render(<App countries={data} />, el);
  }
}

export default { init };
